"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var User_1 = require("../models/User");
var material_1 = require("@mui/material");
var UserService_1 = require("../services/UserService");
var Add_1 = require("@mui/icons-material/Add");
var UserModal_1 = require("./UserModal");
var Edit_1 = require("@mui/icons-material/Edit");
var Password_1 = require("@mui/icons-material/Password");
var GenericModal_1 = require("./GenericModal");
var Toast_1 = require("../shared/utilities/Toast");
var CloudUpload_1 = require("@mui/icons-material/CloudUpload");
var EventService_1 = require("../services/EventService");
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function Admin() {
    var _a = Toast_1.default(), showErrorMessage = _a.showErrorMessage, showSuccessMessage = _a.showSuccessMessage;
    var _b = React.useState(false), ready = _b[0], setReady = _b[1];
    var _c = React.useState(new User_1.UserModel()), resetPasswordUser = _c[0], setResetPasswordUser = _c[1];
    var _d = React.useState([]), users = _d[0], setUsers = _d[1];
    var _e = React.useState([]), visibleUsers = _e[0], setVisibleUsers = _e[1];
    var _f = React.useState(0), page = _f[0], setPage = _f[1];
    var _g = React.useState(10), rowsPerPage = _g[0], setRowsPerPage = _g[1];
    var modalRef = React.useRef(null);
    var resetPasswordModalRef = React.useRef(null);
    var _h = React.useState(false), isMobile = _h[0], setIsMobile = _h[1];
    var _j = React.useState(false), showInactive = _j[0], setShowInactive = _j[1];
    var handleResize = function () {
        if (window.innerWidth < 720) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    };
    var handleChangePage = function (event, newPage) {
        console.log(newPage);
        setPage(newPage);
        setVisibleUsers(users.filter(function (user, index) { return index >= rowsPerPage * newPage && index < rowsPerPage * (newPage + 1); }));
    };
    var handleChangeRowsPerPage = function (event) {
        var newValue = parseInt(event.target.value, 10);
        setRowsPerPage(newValue);
        setPage(0);
        setVisibleUsers(users.filter(function (user, index) { return index < newValue; }));
    };
    var upsertUser = function (user, sendResetPasswordLink) {
        setReady(false);
        if (user.UserId == null || user.UserId == '') {
            UserService_1.default.CreateUser(user.FirstName, user.LastName, user.Email, user.Role, sendResetPasswordLink, showInactive, user.EmailSubscription).then(function (response) {
                if (response != null && response.Users != null) {
                    setUsers(__spreadArray([], response.Users));
                    setVisibleUsers(response.Users.filter(function (user, index) { return index < rowsPerPage; }));
                    showSuccessMessage('User added successfully!');
                }
                else {
                    showErrorMessage('Unknown error occured adding user!');
                }
                setReady(true);
            }, function (error) {
                showErrorMessage(error.message);
                setReady(true);
            });
        }
        else {
            UserService_1.default.UpdateUser(user.UserId, user.FirstName, user.LastName, user.Email, user.Role, user.IsActive, showInactive, user.EmailSubscription).then(function (response) {
                if (response != null && response.Users != null) {
                    setUsers(__spreadArray([], response.Users));
                    setVisibleUsers(response.Users.filter(function (user, index) { return index < rowsPerPage; }));
                    showSuccessMessage('User updated successfully!');
                }
                else {
                    showErrorMessage('Unknown error occured updating user!');
                }
                setReady(true);
            }, function (error) {
                showErrorMessage(error.message);
                setReady(true);
            });
        }
    };
    var resetPassword = function (email) {
        console.log('reseting password');
        setReady(false);
        UserService_1.default.ForgotPassword(email).then(function (response) {
            if (response.IsSuccess) {
                showSuccessMessage('Email sent to ' + email + ' successfully');
            }
            else {
                showErrorMessage('Error occurred sending email to ' + email);
            }
            setReady(true);
        });
    };
    var getUsers = function (showInactiveUsers) {
        setReady(false);
        setShowInactive(showInactiveUsers);
        UserService_1.default.GetUsers(showInactiveUsers).then(function (response) {
            if (response.Users != null && response.error == null) {
                setUsers(response.Users);
                setVisibleUsers(response.Users.filter(function (user, index) { return index < rowsPerPage; }));
            }
            else {
                showErrorMessage('Unknown error occured getting users!');
            }
            setReady(true);
        });
    };
    React.useEffect(function () {
        window.addEventListener("resize", handleResize);
        handleResize();
        getUsers(false);
    }, []);
    var openUserModal = function (user) {
        var _a, _b;
        if (user == null || user.UserId == '') {
            var newUser = new User_1.UserModel();
            modalRef && ((_a = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen(newUser));
        }
        else {
            modalRef && ((_b = modalRef === null || modalRef === void 0 ? void 0 : modalRef.current) === null || _b === void 0 ? void 0 : _b.handleOpen(user));
        }
    };
    var handleShowInactiveChange = function (e) {
        getUsers(e.target.checked);
    };
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3, marginBottom: '40px' } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                React.createElement(material_1.Fab, { color: "primary", style: { float: 'right', marginBottom: '8px' }, variant: "extended", onClick: function () {
                        openUserModal(new User_1.UserModel());
                    } },
                    React.createElement(Add_1.default, null),
                    " Add New User"),
                React.createElement(material_1.Fab, { color: "primary", style: { float: 'right', marginBottom: '8px', marginRight: '8px' }, variant: "extended", onClick: function () {
                        var element = document.getElementById('documentUpload');
                        if (element != null) {
                            element.click();
                            ;
                        }
                    } },
                    React.createElement(CloudUpload_1.default, null),
                    " \u00A0 Upload events list",
                    React.createElement(VisuallyHiddenInput, { id: "documentUpload", type: "file", onChange: function (e) {
                            setReady(false);
                            var file = e.target.files[0];
                            var reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = function () {
                                if (reader.result != null) {
                                    EventService_1.default.UpdateEventsList(reader.result.toString().split('base64,')[1]).then(function (response) {
                                        setReady(true);
                                        if (response.success) {
                                            showSuccessMessage('Successfully updated events list document');
                                        }
                                        else {
                                            showErrorMessage('Error occurred updating events list document');
                                        }
                                    });
                                }
                            };
                            reader.onerror = function (error) {
                                showErrorMessage('Error occurred updating events list document');
                            };
                        } })),
                React.createElement(material_1.FormGroup, null,
                    React.createElement(material_1.FormControlLabel, { control: React.createElement(material_1.Checkbox, { checked: showInactive, onChange: handleShowInactiveChange }), label: "Show Inactive" })),
                React.createElement(material_1.TableContainer, { component: material_1.Paper },
                    React.createElement(material_1.Table, { "aria-label": "simple table" },
                        React.createElement(material_1.TableHead, null,
                            React.createElement(material_1.TableRow, null,
                                React.createElement(material_1.TableCell, { width: "35%" }, "Name"),
                                !isMobile &&
                                    React.createElement(material_1.TableCell, { width: "30%" }, "Email"),
                                React.createElement(material_1.TableCell, { width: "15%" }, "Role"),
                                React.createElement(material_1.TableCell, { width: "10%" }, "Active"),
                                React.createElement(material_1.TableCell, { width: "10%" }))),
                        React.createElement(material_1.TableBody, null, visibleUsers.map(function (user) { return (React.createElement(material_1.TableRow, { key: user.UserId, sx: { '&:last-child td, &:last-child th': { border: 0 } } },
                            React.createElement(material_1.TableCell, { width: "35%", component: "th", scope: "row" }, user.FirstName + " " + user.LastName),
                            !isMobile &&
                                React.createElement(material_1.TableCell, { width: "30%" }, user.Email),
                            React.createElement(material_1.TableCell, { width: "15%" }, user.Role),
                            React.createElement(material_1.TableCell, { width: "10%" }, user.IsActive ? 'Active' : 'Inactive'),
                            React.createElement(material_1.TableCell, { width: "10%" },
                                React.createElement(material_1.IconButton, { edge: "end", "aria-label": "comments", style: { float: 'right' }, onClick: function () {
                                        openUserModal(user);
                                    } },
                                    React.createElement(Edit_1.default, null)),
                                React.createElement(material_1.IconButton, { edge: "end", "aria-label": "comments", style: { float: 'right' }, onClick: function () {
                                        var _a;
                                        setResetPasswordUser(user);
                                        resetPasswordModalRef && ((_a = resetPasswordModalRef === null || resetPasswordModalRef === void 0 ? void 0 : resetPasswordModalRef.current) === null || _a === void 0 ? void 0 : _a.handleOpen());
                                    } },
                                    React.createElement(Password_1.default, null))))); })))),
                React.createElement(material_1.TablePagination, { rowsPerPageOptions: [5, 10, 25], component: "div", count: users.length, rowsPerPage: rowsPerPage, page: page, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })),
        React.createElement(GenericModal_1.default, { ref: resetPasswordModalRef, text: 'Are you sure you want to reset password for user ' + (resetPasswordUser === null || resetPasswordUser === void 0 ? void 0 : resetPasswordUser.FirstName) + ' ' + (resetPasswordUser === null || resetPasswordUser === void 0 ? void 0 : resetPasswordUser.LastName) + '?', action: resetPassword, value: resetPasswordUser === null || resetPasswordUser === void 0 ? void 0 : resetPasswordUser.Email }),
        React.createElement(UserModal_1.default, { ref: modalRef, upsertUser: upsertUser })));
}
exports.default = Admin;
//# sourceMappingURL=Admin.js.map